module.exports = __webpack_public_path__ + "web/img/z2.186fa6ce.png";